import UserManagement from './UserManagement'
import withLayout from 'components/layout'

export default withLayout(UserManagement)
